import React, {useEffect, useState} from "react";
import {Box, Button, Chip} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {LockIcon} from "@hugeicons/core-free-icons";
import {FlowProtectionRepository} from "../../../repositories/FlowProtectionRepository";
import {FlowProtectionPasswordModal} from "../../../components/modals/FlowProtectionPasswordModal";
import {useRegistryProject} from "../RegistryProjectContext";
import {SectionHeader} from "./settingsStyles";

// Protection tab: the project's password that gates seeing protected user messages in plain text
// (in the dashboard and supervision, see FlowProtectionButton)
export const RegistryProtectionSettings = () => {
  const {project} = useRegistryProject();
  const projectId = project?.id;
  // null = unknown (loading or failed)
  const [configured, setConfigured] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const fetchStatus = () => {
    if (!projectId) return;
    FlowProtectionRepository.getStatus(projectId)
      .then(response => setConfigured(!!response?.data?.configured))
      .catch(() => setConfigured(null));
  };

  useEffect(() => {
    fetchStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectId]);

  return (
    <Box sx={{px: {xs: 2, md: 4}, py: {xs: 2, md: 3}}}>
      <SectionHeader
        icon={<HugeiconsIcon icon={LockIcon} size={18}/>}
        title={"Message Protection"}
        description={configured
          ? "A password is set for this project. Rotate it any time - the current password is required."
          : "Set a password to gate access to protected user messages in the dashboard and supervision."}
        action={
          <Button
            onClick={() => setModalOpen(true)}
            disabled={!projectId || configured === null}
            sx={{
              textTransform: "none", fontWeight: 600, fontSize: 13, borderRadius: "10px",
              bgcolor: "rgba(132, 145, 247, 0.12)", color: "#4B55C9", "&:hover": {bgcolor: "rgba(132, 145, 247, 0.2)"},
              "&.Mui-disabled": {bgcolor: "#F0F0F6", color: "#B4B4C3"},
            }}
          >
            {configured ? "Update Password" : "Set Password"}
          </Button>
        }
      />
      {configured !== null && (
        <Chip
          size={"small"}
          label={configured ? "Configured" : "Not set"}
          color={configured ? "success" : "default"}
          variant={configured ? "filled" : "outlined"}
          sx={{fontWeight: 500, height: 22, ml: {sm: 6}}}
        />
      )}
      <FlowProtectionPasswordModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        projectId={projectId}
        mode={configured ? "update" : "set"}
        onSuccess={fetchStatus}
      />
    </Box>
  );
};
